import React, { useState } from "react";
import { getReportedUserDetails } from "../actions";
import { useDispatch, useSelector } from "react-redux";
import Avatar from "../../../assets/images/DefaultProfilePic.jpg";
import ProperSpinner from "../../../components/spinner/ProperSpinner";
import ReportedByUserTable from "../../../components/reportManagement/ReportedByUserTable";

const UserDetails = ({ selectedUserId, setUserStatus }) => {
  const dispatch = useDispatch();
  const [loaderForUserDetails, setLoaderForUserDetails] = useState(false);
  const { userDetails } = useSelector((state) => state.ReportReducer.user);
  console.log('user details :',userDetails);
  React.useEffect(() => {
    setLoaderForUserDetails(true);
    dispatch(
      getReportedUserDetails(selectedUserId, (response) => {
        setUserStatus(response.data?.status);
        setLoaderForUserDetails(false);
      })
    );
  }, []);

  if (loaderForUserDetails) {
    return <ProperSpinner />;
  }

  return (
    <div>
      <div>{<UserDetailsView userDetails={userDetails} />}</div>
      <div>
        <ReportedByUserTable selectedUserId={selectedUserId} />
      </div>
    </div>
  );
};

const UserDetailsView = React.memo(({ userDetails }) => {
  return (
    <div className="rm--user--details--container">
      <div className="rm--img--parent--container">
        <figure className="rm--image--container">
          <img
            src={userDetails?.profileImage ? userDetails.profileImage : Avatar}
            alt="Profile Photo"
            className="rm--image"
          />
        </figure>
      </div>
      <div className="rm--data--container">
        <div className="rm--data--subcontainer">
          <div className="rm--fields--container">
            <p className="rm--label">{"Full Name"}</p>
            <p className="rm--data">
              {userDetails.firstName + " " + userDetails.lastName || "N/A"}
            </p>
          </div>
          <div className="rm--fields--container">
            <p className="rm--label">{"Email Address"}</p>
            <p className="rm--data">{userDetails.email || "N/A"}</p>
          </div>
        </div>

        <div className="rm--data--subcontainer">
          <div className="rm--fields--container">
            <p className="rm--label">{"Country"}</p>
            <p className="rm--data">{userDetails.country || "N/A"}</p>
          </div>
          <div className="rm--fields--container">
            <p className="rm--label">{"Mobile No."}</p>
            <p className="rm--data">{userDetails.phoneNo || "N/A"}</p>
          </div>
        </div>
      </div>
    </div>
  );
});

export default UserDetails;
